/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DigitizingMelcoDigitizingModelsOrderCreate,
    DigitizingMelcoDigitizingModelsOrderCreateFromJSON,
    DigitizingMelcoDigitizingModelsOrderCreateToJSON,
    DigitizingMelcoDigitizingModelsOrderResponse,
    DigitizingMelcoDigitizingModelsOrderResponseFromJSON,
    DigitizingMelcoDigitizingModelsOrderResponseToJSON,
    DigitizingMelcoDigitizingModelsOrderSave,
    DigitizingMelcoDigitizingModelsOrderSaveFromJSON,
    DigitizingMelcoDigitizingModelsOrderSaveToJSON,
    DigitizingMelcoModelsError,
    DigitizingMelcoModelsErrorFromJSON,
    DigitizingMelcoModelsErrorToJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemFromJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemToJSON,
} from '../models';

export interface DigitizingOrdersApiDigitizingCreateRequest {
    digitizingMelcoDigitizingModelsOrderCreate?: DigitizingMelcoDigitizingModelsOrderCreate;
}

export interface DigitizingOrdersApiDigitizingGetRequest {
    id: string;
}

export interface DigitizingOrdersApiDigitizingGetListRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    orderStatusList?: string;
}

export interface DigitizingOrdersApiDigitizingUpdateRequest {
    id: string;
    digitizingMelcoDigitizingModelsOrderSave?: DigitizingMelcoDigitizingModelsOrderSave;
}

/**
 * 
 */
export class DigitizingOrdersApi extends runtime.BaseAPI {

    /**
     */
    async digitizingCreateRaw(requestParameters: DigitizingOrdersApiDigitizingCreateRequest): Promise<runtime.ApiResponse<DigitizingMelcoDigitizingModelsOrderResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/digitizing/orders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DigitizingMelcoDigitizingModelsOrderCreateToJSON(requestParameters.digitizingMelcoDigitizingModelsOrderCreate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingMelcoDigitizingModelsOrderResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizingCreate(requestParameters: DigitizingOrdersApiDigitizingCreateRequest): Promise<DigitizingMelcoDigitizingModelsOrderResponse> {
        const response = await this.digitizingCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingGetRaw(requestParameters: DigitizingOrdersApiDigitizingGetRequest): Promise<runtime.ApiResponse<DigitizingMelcoDigitizingModelsOrderResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizingGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitizing/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingMelcoDigitizingModelsOrderResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGet(requestParameters: DigitizingOrdersApiDigitizingGetRequest): Promise<DigitizingMelcoDigitizingModelsOrderResponse> {
        const response = await this.digitizingGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingGetListRaw(requestParameters: DigitizingOrdersApiDigitizingGetListRequest): Promise<runtime.ApiResponse<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.orderStatusList !== undefined) {
            queryParameters['order_status_list'] = requestParameters.orderStatusList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitizing/orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetList(requestParameters: DigitizingOrdersApiDigitizingGetListRequest): Promise<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem> {
        const response = await this.digitizingGetListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingUpdateRaw(requestParameters: DigitizingOrdersApiDigitizingUpdateRequest): Promise<runtime.ApiResponse<DigitizingMelcoDigitizingModelsOrderResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizingUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/digitizing/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DigitizingMelcoDigitizingModelsOrderSaveToJSON(requestParameters.digitizingMelcoDigitizingModelsOrderSave),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingMelcoDigitizingModelsOrderResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizingUpdate(requestParameters: DigitizingOrdersApiDigitizingUpdateRequest): Promise<DigitizingMelcoDigitizingModelsOrderResponse> {
        const response = await this.digitizingUpdateRaw(requestParameters);
        return await response.value();
    }

}
